/**
 * Human-readable label for a leave's session range.
 *
 * Convention: Session 1 = first half (morning), Session 2 = second half
 * (afternoon). The stored session_from/session_to encode the leave's span:
 *   Session1 -> Session2  = Full Day
 *   Session1 -> Session1  = First Half (Morning)   (half day)
 *   Session2 -> Session2  = Second Half (Afternoon) (half day)
 *
 * Falls back to the raw values for any unexpected combination so nothing is
 * hidden if older/odd data shows up.
 */
export const sessionLabel = (from, to) => {
  if (from === 'Session1' && to === 'Session1') return 'First Half (Morning)';
  if (from === 'Session2' && to === 'Session2') return 'Second Half (Afternoon)';
  if (from === 'Session1' && to === 'Session2') return 'Full Day';
  if (!from && !to) return '—';
  return `${from || '?'} to ${to || '?'}`;
};
